import { labelForRequestedRole } from './requestRoles';
import { formatToolStartDateDisplay } from './onboardingFormOptions';

function yesNo(value) {
  if (value === true) return 'Yes';
  if (value === false) return 'No';
  return '';
}

function list(value) {
  if (Array.isArray(value) && value.length) return value.join(', ');
  return '';
}

/**
 * Review rows for VE onboarding (and leftover fields from older requests).
 */
export function onboardingReviewRows(request) {
  const payload = request?.payload && typeof request.payload === 'object' ? request.payload : {};
  return [
    { label: 'Title', value: payload.title || '' },
    { label: 'Email', value: request?.email || '' },
    { label: 'Phone', value: request?.phone || payload.phone || '' },
    { label: 'Objective', value: payload.objective || '' },
    { label: 'Role', value: labelForRequestedRole(request?.requestedRole) },
    {
      label: 'Submitted',
      value: request?.submittedAt ? new Date(request.submittedAt).toLocaleString() : '',
    },
    { label: 'Course category', value: payload.courseCategoryName || '' },
    { label: 'Mode of batch', value: payload.modeOfBatch || '' },
    {
      label: 'Total fees INR',
      value:
        payload.totalFeesInr == null || payload.totalFeesInr === ''
          ? ''
          : `${payload.totalFeesInr} INR`,
    },
    { label: 'Need to send welcome email?', value: yesNo(payload.needWelcomeEmail) },
    { label: 'Need MyAcademy access?', value: yesNo(payload.needMyAcademyAccess) },
    { label: 'Tool access', value: yesNo(payload.toolAccess) },
    {
      label: 'Tool access duration (weeks)',
      value:
        payload.toolAccessDurationWeeks == null ? '' : String(payload.toolAccessDurationWeeks),
    },
    {
      label: 'Start date for tool access',
      value: payload.toolAccessStartDate
        ? formatToolStartDateDisplay(payload.toolAccessStartDate)
        : '',
    },
    {
      label: 'Requirement of special machine (VNC only)?',
      value: yesNo(payload.specialMachineVnc),
    },
    { label: 'List of tool access (VNC machine)', value: list(payload.vncTools) },
    { label: 'List of tool access (Putty machine)', value: list(payload.puttyTools) },
    {
      label: 'List of tool access (special machine - VNC only)',
      value: list(payload.specialVncTools),
    },
    { label: 'PDK grp permission', value: list(payload.pdkGrpPermissions) },
    { label: 'Labs need to copy in home location', value: payload.labsCopyHome || '' },
    {
      label: 'Labs access (grp permission or copy in home location)',
      value: list(payload.labsAccess),
    },
    { label: 'Submitted by', value: payload.submittedByEmail || '' },
    { label: 'Course', value: payload.courseName || '' },
    { label: 'Batch', value: payload.batchId || '' },
    { label: 'Notes', value: payload.notes || '' },
  ].filter((row) => String(row.value || '').trim() !== '');
}
